import { render, staticRenderFns } from "./card-balance-view.vue?vue&type=template&id=06bd2534&scoped=true&"
import script from "./card-balance-view.vue?vue&type=script&lang=js&"
export * from "./card-balance-view.vue?vue&type=script&lang=js&"
import style0 from "./card-balance-view.vue?vue&type=style&index=0&id=06bd2534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd2534",
  null
  
)

export default component.exports